module.exports = __webpack_public_path__ + "img/groupBackgroundImg.cbd876b0.png";